// src/components/RichTextEditor.tsx
import React, { useState, useMemo } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // Import Quill's CSS for 'snow' theme
import { Form } from 'react-bootstrap'; // Assuming you use Form from react-bootstrap

interface RichTextEditorProps {
    value: string;
    onChange: (content: string) => void;
    placeholder?: string;
    label?: string;
    id?: string;
    // You can add more props as needed, e.g., for error states, disabled, etc.
}

const RichTextEditor: React.FC<RichTextEditorProps> = ({
    value,
    onChange,
    placeholder,
    label,
    id,
}) => {
    // Quill modules to configure the toolbar options
    const modules = useMemo(() => ({
        toolbar: [
            [{ 'header': [1, 2, false] }], // Headers: H1, H2, Normal
            ['bold', 'italic', 'underline', 'strike'], // Inline styles
            [{ 'list': 'ordered' }, { 'list': 'bullet' }], // Lists
            // You can add more options here:
            // [{ 'script': 'sub'}, { 'script': 'super' }], // Subscript/Superscript
            [{ 'indent': '-1' }, { 'indent': '+1' }], // Indent/Outdent
            // [{ 'direction': 'rtl' }], // Text direction
            // [{ 'color': [] }, { 'background': [] }], // Text/Background color
            // [{ 'font': [] }], // Font family
            // [{ 'align': [] }], // Text alignment
            // ['link', 'image', 'video'], // Embeds
            ['clean'] // Remove formatting
        ],
    }), []);

    // Quill formats to allow for the content
    const formats = [
        'header',
        'bold', 'italic', 'underline', 'strike', 'blockquote',
        'list', 'bullet', 'indent', 'link'
        // Add more formats if you enable them in modules
        // 'image', 'video',
    ];

    return (
        <Form.Group className="mb-3" controlId={id}>
            {label && <Form.Label>{label}</Form.Label>}
            <ReactQuill
                theme="snow" // 'snow' is a clean, default theme; 'bubble' is another option
                value={value}
                onChange={onChange}
                modules={modules}
                formats={formats}
                placeholder={placeholder}
                className="my-quill-editor"


            />
        </Form.Group>
    );
};

export default RichTextEditor;